import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/DBContext"; // Firebase functions

export default function Example() {
  const { fetchWidgets, currentUser } = useAuth();
  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    const loadWidgets = async () => {
      if (!currentUser) return;

      try {
        const fetchedWidgets = await fetchWidgets();
        setWidgets(fetchedWidgets);
      } catch (error) {
        // console.error("Error loading widgets:", error);
      }
    };

    loadWidgets();
  }, [fetchWidgets, currentUser]);

  // Conditionally render nothing if there is no current user
  if (!currentUser) return null;

  return (
    <div className="overflow-hidden bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {widgets.map((widget, index) => (
          <div
            key={index}
            className="mx-auto my-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2"
          >
            {index % 2 === 0 ? (
              <>
                {/* Text on the left, image on the right for even indexes */}
                <div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                    <h2 className="text-base font-semibold text-indigo-600">{widget.topic}</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                      {widget.header}
                    </p>
                    <p className="mt-6 text-lg text-gray-600">{widget.description}</p>
                  </div>
                </div>
                <img
                  alt="Product screenshot"
                  src={widget.image}
                  width={2432}
                  height={1442}
                  className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-4 lg:-ml-0"
                />
              </>
            ) : (
              <>
                {/* Image on the left, text on the right for odd indexes */}
                <img
                  alt="Product screenshot"
                  src={widget.image}
                  width={2432}
                  height={1442}
                  className="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem] md:-ml-48 lg:-ml-64 xl:-ml-96"
                />
                <div className="lg:pr-8 lg:pt-4">
                  <div className="lg:max-w-lg">
                    <h2 className="text-base font-semibold text-indigo-600">{widget.topic}</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                      {widget.header}
                    </p>
                    <p className="mt-6 text-lg text-gray-600">{widget.description}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
